module.exports = __webpack_public_path__ + "images/stickers/pete-broken.9703d25e0196f5d1a154.png";